export default {"src":"/_next/static/media/Visa.c6c95db5.svg","height":40,"width":40};